import type { ReactNode, RefObject } from 'react';

import type { ContentBlock } from '../../types.js';
import { RelatedChipsBlock } from './RelatedChipsBlock.jsx';

type Props = {
  blockRefs: RefObject<Map<string, HTMLDivElement>>;
  containerRef?: RefObject<HTMLDivElement | null>;
  blockId: string;
  children: ReactNode;
  relatedBlocks: ContentBlock[];
};

const RelatedBlockWrapper = ({
  blockId,
  blockRefs,
  containerRef,
  children,
  relatedBlocks,
}: Props) => {
  const setBlockRef = (element: HTMLDivElement | null) => {
    if (element) {
      blockRefs.current.set(blockId, element);
    }
  };

  const scrollToItem = (element: string) => {
    const el = blockRefs.current.get(element);

    if (el && containerRef?.current) {
      const top =
        el.getBoundingClientRect().top -
        containerRef.current.getBoundingClientRect().top +
        containerRef.current.scrollTop;

      containerRef.current.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div
      className="flex flex-col gap-2"
      ref={setBlockRef}
      aria-label="related-block-wrapper"
    >
      {children}
      {relatedBlocks.length ? (
        <RelatedChipsBlock
          relatedBlocks={relatedBlocks}
          scrollToItem={scrollToItem}
        />
      ) : null}
    </div>
  );
};

export { RelatedBlockWrapper };
